import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getCardIcon } from '../../../utils/utils';
import Text from '../../elements/text/Text';

const StyledCardHeader = styled(CardHeader)({
  textAlign: 'left',
  '& .MuiCardHeader-action': {
    alignSelf: 'center',
    marginTop: 0,
  },
});

const CreditCard = ({ card }) => {
  const { t } = useTranslation();

  const formatMonth = (month) => `0${month}`.slice(-2);

  return (
    <Card variant="outlined" style={{ marginBottom: 15 }}>
      <StyledCardHeader
        avatar={getCardIcon(card?.brand, 50)}
        title={
          <Text>{`${card?.brand} ${t('billing.creditCardEnding', {
            ns: 'project',
            number: card?.number,
          })}`}</Text>
        }
        subheader={
          <Text caption>
            {t('billing.creditCardExpiration', {
              ns: 'project',
              number: `${formatMonth(card?.expireMonth)}/${card?.expireYear}`,
            })}
          </Text>
        }
      />
    </Card>
  );
};

CreditCard.propTypes = {
  card: PropTypes.object,
};

export default CreditCard;
